const createBlurOverlay = () => {
    const overlay = document.createElement('div');
    overlay.classList.add('blur');
    document.body.appendChild(overlay);
    return overlay;
};

const removeBlurOverlay = (overlay) => {
    if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
    }
};

const checkBannerVisibility = () => {
    const bannerContainer = document.querySelector('div.cky-consent-container.cky-box-bottom-left');
    const overlay = document.querySelector('.blur');

    if (bannerContainer && !bannerContainer.classList.contains('cky-hide')) {
        if (!overlay) {
            createBlurOverlay();
        }
    } else {
        removeBlurOverlay(overlay);
    }
};

checkBannerVisibility();

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || (mutation.type === 'attributes' && mutation.attributeName === 'class')) {
            checkBannerVisibility();
        }
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
});